import InfoContainer from "./InfoContainer";

export default InfoContainer;
